import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminNews = lazy(() => import("@/pages/admin/AdminNews"));

export const Route = createFileRoute("/admin/nyheter")({
  component: () => <AdminNews />,
});
